import React, { useState } from 'react'
import { WorkModel } from '@Entities/work/work'
import ViewWorkHeader from '@Components/ViewWork/Headers/ViewWorkHeader'
import NakedButton from '@Components/Buttons/NakedButton'
import { ICONS } from '@Const/common'

interface PublicWorkHeaderProps {
    work: WorkModel
}

const PublicWorkHeader = (props: PublicWorkHeaderProps) => {
    const [copied, setCopied] = useState(false)

    const copyURL = async () => {
        await navigator.clipboard.writeText(window.location.href)
        setCopied(true)
        setTimeout(() => {
            setCopied(false)
        }, 2000)
    }

    return (
        <ViewWorkHeader work={props.work} backText="< Back to public search results">
            <NakedButton onClick={copyURL}>
                <img src={ICONS.share} alt="Copy work link" />
                {copied ? 'Copied!' : 'Copy work link'}
            </NakedButton>
        </ViewWorkHeader>
    )
}

export default PublicWorkHeader
